import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ApiConnectService } from '../../../services/api-connect.service';
import {
  VACATION_API_PATHS,
  VACATION_QUERY_PARAM
} from './vacation-api.constants';
import {
  VacationAvailabilityResponse,
  VacationBalanceResponse,
  VacationBookingPreviewResponse,
  VacationBookingRequest,
  VacationBookingResponse,
  VacationEntriesResponse,
  VacationGroupCalendarResponse,
  VacationGroupPresenceResponse,
  VacationPolicy,
  VacationPolicyUpdateRequest
} from './vacation.models';

@Injectable()
export class VacationApiService {

  constructor(
    private http: HttpClient,
    private apiConnectService: ApiConnectService
  ) {}

  public getMyBalance(asOf: string): Observable<VacationBalanceResponse> {
    const params = new HttpParams().set(VACATION_QUERY_PARAM.AS_OF, asOf);
    return this.http.get<VacationBalanceResponse>(
      this.url(VACATION_API_PATHS.MY_BALANCE),
      { params: params }
    );
  }

  public getMyAvailability(
    from: string,
    to: string
  ): Observable<VacationAvailabilityResponse> {
    return this.http.get<VacationAvailabilityResponse>(
      this.url(VACATION_API_PATHS.MY_AVAILABILITY),
      { params: this.dateRangeParams(from, to) }
    );
  }

  public getMyEntries(page: number, size: number): Observable<VacationEntriesResponse> {
    const params = new HttpParams()
      .set(VACATION_QUERY_PARAM.PAGE, String(page))
      .set(VACATION_QUERY_PARAM.SIZE, String(size));
    return this.http.get<VacationEntriesResponse>(
      this.url(VACATION_API_PATHS.MY_ENTRIES),
      { params: params }
    );
  }

  public previewBooking(
    request: VacationBookingRequest
  ): Observable<VacationBookingPreviewResponse> {
    return this.http.post<VacationBookingPreviewResponse>(
      this.url(VACATION_API_PATHS.BOOKING_PREVIEW),
      request
    );
  }

  public createBooking(
    request: VacationBookingRequest
  ): Observable<VacationBookingResponse> {
    return this.http.post<VacationBookingResponse>(
      this.url(VACATION_API_PATHS.BOOKINGS),
      request
    );
  }

  public confirmBooking(bookingId: string): Observable<VacationBookingResponse> {
    return this.http.post<VacationBookingResponse>(
      this.url(VACATION_API_PATHS.BOOKING_CONFIRM(bookingId)),
      {}
    );
  }

  public cancelBooking(bookingId: string): Observable<void> {
    return this.http.delete<void>(
      this.url(VACATION_API_PATHS.BOOKING_BY_ID(bookingId))
    );
  }

  public getGroupCalendar(
    groupId: string,
    from: string,
    to: string
  ): Observable<VacationGroupCalendarResponse> {
    return this.http.get<VacationGroupCalendarResponse>(
      this.url(VACATION_API_PATHS.GROUP_CALENDAR(groupId)),
      { params: this.dateRangeParams(from, to) }
    );
  }

  public getGroupPresence(groupId: string): Observable<VacationGroupPresenceResponse> {
    return this.http.get<VacationGroupPresenceResponse>(
      this.url(VACATION_API_PATHS.GROUP_PRESENCE(groupId))
    );
  }

  public getVacationPolicy(): Observable<VacationPolicy> {
    return this.http.get<VacationPolicy>(
      this.url(VACATION_API_PATHS.ADMIN_POLICY)
    );
  }

  public updateVacationPolicy(
    request: VacationPolicyUpdateRequest
  ): Observable<VacationPolicy> {
    return this.http.put<VacationPolicy>(
      this.url(VACATION_API_PATHS.ADMIN_POLICY),
      request
    );
  }

  private dateRangeParams(from: string, to: string): HttpParams {
    return new HttpParams()
      .set(VACATION_QUERY_PARAM.FROM, from)
      .set(VACATION_QUERY_PARAM.TO, to);
  }

  private url(path: string): string {
    return this.apiConnectService.baseApiUrl + path;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-api.service.ts